<div class="calendar-settings-modal">
    <div class="form-group">
        <label class="label" for="booking-calendar-select">
            Booking Calendar
            <i class="fa fa-info-circle" title="Checkride events will be created on this calendar"></i>
        </label>
        <select id="booking-calendar-select" class="form-control"
            [(ngModel)]="calendarReference.MainCalendarKey" (change)="setupAdditionalCalendars()">
            <option *ngFor="let calendar of allCalendars" [value]="calendar.Id">{{calendar.Name}}</option>
        </select>
    </div>

    <div class="form-group" *ngIf="alternateCalendars.length">
        <label class="label">
            Availability Calendars
            <i class="fa fa-info-circle" title="These calendars are used to determine availability only"></i>
        </label>
        <p-multiSelect [options]="alternateCalendars" [(ngModel)]="calendarConfig.AdditionalCalendars"
            optionLabel="Name" optionValue="Id" display="chip" appendTo="body" baseZIndex="2000"
            [autoZIndex]="false" class="multi-edit-auto-expand"></p-multiSelect>
    </div>

    <div class="remove-access">
        <button type="button" class="btn btn-outline-warning" (click)="removeAccess()" [disabled]="removingAccess">
            {{removingAccess ? 'Removing Access...' : 'Remove Google Calendar Access'}}
        </button>
    </div>

    <dw-message [(message)]="message"></dw-message>
</div>
